import { WeeeIcon } from '@/components/common/Icon';
import GroupEditNav from '@/components/group-order/components/GroupEditNav';

export default function BackBtn({
  isHost,
  vendorTitle,
  intervalGroupOrderData
}: {
  isHost?: boolean; //是否团长, 团员  模式展示分2种
  vendorTitle?: string;
  intervalGroupOrderData: any;
}) {
  return (
    <GroupEditNav
      isHost={isHost}
      vendorTitle={vendorTitle}
      intervalGroupOrderData={intervalGroupOrderData}
      onlyChildPopup={'leave'}>
      <WeeeIcon data-testid="btn-close" style={{ fontSize: 18 }} className="pr-3" type="iconclose" />
    </GroupEditNav>
  );
}
